import React, { memo, useMemo, useCallback } from 'react';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import CONFIG from './TableConfig';
import NewEntityList from 'containers/components/NewEntityList';
import { getLiteral } from 'utils/getLiteral';
import NoData from 'components/SvgIcons/emptyScreen/NoData';
import Campaigns from 'components/SvgIcons/emptyScreen/Campaigns';
import MarketingCampaignRow from './components/MarketingCampaignRow';

const Content = memo(() => {
    const tableParams = useMemo(() => {
        const newTableParams = {};

        return newTableParams;
    }, []);

    const config = useMemo(() => {
        return CONFIG(tableParams);
    }, [tableParams]);

    const emptyViewProps = useMemo(
        () => ({
            canCreate: true,
            icon: <NoData />,
            iconFirstTime: <Campaigns />,
            iconType: 'image',
            titleFirstTime: getLiteral('label_empty_screen_campaigns'),
            subtitleFirstTime: getLiteral('label_empty_screen_campaigns_desc'),
        }),
        [],
    );

    const getRowNodeId = useCallback((data) => data.id, []);

    return (
        <div className="campaigns-table">
            {config && (
                <NewEntityList
                    id="fm-grid-campaigns-marketing"
                    entity={CAMPAIGNS_MARKETING}
                    config={config}
                    initOnReady={true}
                    useCache={true}
                    useSort={true}
                    useBackendSortWithoutLazyLoad={true}
                    useDragColumns={true}
                    getRowNodeId={getRowNodeId}
                    emptyViewProps={emptyViewProps}
                    useFullWidthDivider={true}
                    components={{ marketingCampaignRow: MarketingCampaignRow }}
                    rowHeight={72}
                    loaderPlaceholderRowHeight={72}
                />
            )}
        </div>
    );
});

export default Content;
